import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";
import { alpha } from "@mui/material/styles";

export const useStyles = makeStyles<{ streamingModeColor: string }>()((theme: Theme, { streamingModeColor }) => ({
    container: {
        position: "relative",
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.palette.common.black,
    },
    canvas: {
        width: "100%",
        height: "100%",
        objectFit: "contain",
        cursor: "crosshair",
        display: "block",
    },
    statusOverlay: {
        position: "absolute",
        top: 10,
        left: 10,
        padding: "8px 12px",
        backgroundColor: alpha(theme.palette.common.black, 0.7),
        color: theme.palette.common.white,
        borderRadius: "4px",
        fontSize: "12px",
        fontFamily: "monospace",
        zIndex: 1000,
    },
    statusError: {
        color: theme.palette.emteria.error,
    },
    statusWarning: {
        color: theme.palette.emteria.warning,
    },
    statusSuccess: {
        color: theme.palette.emteria.success,
    },
    statusIndicator: {
        backgroundColor: streamingModeColor,
        marginTop: "4px",
        padding: "4px 8px",
        borderRadius: "4px",
        fontSize: "11px",
        fontWeight: 500,
        display: "inline-flex",
        alignItems: "center",
        color: theme.palette.common.white,
    },
    retryButton: {
        marginTop: "4px",
        padding: "4px 8px",
        borderRadius: "4px",
        fontSize: "11px",
        fontWeight: 500,
        backgroundColor: alpha(theme.palette.primary.main, 0.8),
        color: theme.palette.common.white,
        border: "none",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: alpha(theme.palette.primary.main, 1),
        },
    },
    modeButtonsOverlay: {
        position: "absolute",
        top: 10,
        right: 10,
        padding: "8px 12px",
        backgroundColor: alpha(theme.palette.common.black, 0.7),
        borderRadius: "4px",
        zIndex: 1000,
        display: "flex",
        gap: "6px",
        flexWrap: "wrap",
    },
    modeLabel: {
        marginRight: theme.spacing(2),
    },
    modeButtonActive: {
        backgroundColor: alpha(theme.palette.emteria.primary, 0.8),
    },
    modeButton: {
        padding: "6px 12px",
        borderRadius: "4px",
        fontSize: "12px",
        fontWeight: 500,
        color: theme.palette.common.white,
        border: `1px solid ${alpha(theme.palette.common.white, 0.3)}`,
        cursor: "pointer",
        backgroundColor: alpha(theme.palette.common.black, 0.5),
        transition: "background-color 0.2s",
        "&:hover": {
            backgroundColor: alpha(theme.palette.common.white, 0.1),
        },
    },
}));
